module.exports = __webpack_public_path__ + "img/cc01b89cc908409c93fea5d460ab6a4e-60.869bc1cd.jpg";